import React, { useState } from 'react';
import Modal from '@hubins/components/Modal';
import { useMiddleman } from '@hubins/middleman';
import Button, { ButtonWrap } from '@hubins/components/Button';
import Dropdown from '@hubins/components/Dropdown';
import Heading from '@hubins/components/Heading';
import ErrorMessage from 'components/ErrorMessage';

const privateOptions = [
  {
    id: 'pep',
    title: 'PEP',
  },
  {
    id: 'sanctions',
    title: 'Sanctions',
  }
];

const companyOptions = [
  {
    id: 'sanctions',
    title: 'Sanctions',
  },
  {
    id: 'company-pep',
    title: 'PEP',
  }
];


const ScreeningModal = ({ client, refetch }) => {
  const middleman = useMiddleman();


  const [open, setOpen] = useState(false);
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const isCompany = client.type === 'COMPANY';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);
    try {
      await middleman.promisePost('/ql/crm/screening', {
        profileUuid: client.uuid,
        type,
      })
      setOpen(false);
      refetch();
    } catch (e) {
      setError(true);
      console.error(e);
    }
    setLoading(false);
  }

  return (
    <>
      <ButtonWrap>
        <Button onClick={() => setOpen(true)} icon="add">
          New Screening
        </Button>
      </ButtonWrap>
      <Modal open={open} callback={setOpen} shouldCloseOnOverlayClick closeButton>
        <form onSubmit={handleSubmit}>
          <Heading className='s-bottom-l' size="4">New Screening</Heading>
          <Dropdown
            placeholder='Select a type'
            className="input-max-width"
            label="Type"
            options={isCompany ? companyOptions : privateOptions}
            value={type}
            callback={setType}
          />
          <Button className="s-top-m" type="submit" disabled={!type || loading} loading={loading}>Create</Button>
          {error && <ErrorMessage text="Failed to create screening" showError={!!error} />}
        </form>
      </Modal>
    </>
  )
};

export default ScreeningModal;